/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'
import * as ConvoDefs from '../convo/defs.defs.js'

const $nsid = 'chat.bsky.group.defs'

type $nsid = typeof $nsid

export { $nsid }

type LinkEnabledStatus = 'enabled' | 'disabled' | l.UnknownString

export type { LinkEnabledStatus }

const linkEnabledStatus = /*#__PURE__*/ l.string<{
  knownValues: ['enabled', 'disabled']
}>()

export { linkEnabledStatus }

type JoinRule = 'anyone' | 'followedByOwner' | l.UnknownString

export type { JoinRule }

const joinRule = /*#__PURE__*/ l.string<{
  knownValues: ['anyone', 'followedByOwner']
}>()

export { joinRule }

/** Join link view to be used within a group view, so the convo is surrounding, not specified inside this view. */
type JoinLinkView = {
  $type?: 'chat.bsky.group.defs#joinLinkView'
  code: string
  enabledStatus: LinkEnabledStatus
  requireApproval: boolean
  joinRule: JoinRule
  createdAt: l.DatetimeString
}

export type { JoinLinkView }

/** Join link view to be used within a group view, so the convo is surrounding, not specified inside this view. */
const joinLinkView = /*#__PURE__*/ l.typedObject<JoinLinkView>(
  $nsid,
  'joinLinkView',
  /*#__PURE__*/ l.object({
    code: /*#__PURE__*/ l.string(),
    enabledStatus: /*#__PURE__*/ l.ref<LinkEnabledStatus>(
      (() => linkEnabledStatus) as any,
    ),
    requireApproval: /*#__PURE__*/ l.boolean(),
    joinRule: /*#__PURE__*/ l.ref<JoinRule>((() => joinRule) as any),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { joinLinkView }

/** Preview that can be shown in feeds, including to unauthenticated viewers. */
type JoinLinkPreviewView = {
  $type?: 'chat.bsky.group.defs#joinLinkPreviewView'
  convoId: string
  code: string
  name: string
  owner: ActorDefs.ProfileViewBasic
  memberCount: number
  memberLimit: number
  requireApproval: boolean
  joinRule: JoinRule

  /**
   * Present only if the request is authenticated and the user is a member of the group.
   */
  convo?: ConvoDefs.ConvoView
  viewer?: JoinLinkViewerState
}

export type { JoinLinkPreviewView }

/** Preview that can be shown in feeds, including to unauthenticated viewers. */
const joinLinkPreviewView = /*#__PURE__*/ l.typedObject<JoinLinkPreviewView>(
  $nsid,
  'joinLinkPreviewView',
  /*#__PURE__*/ l.object({
    convoId: /*#__PURE__*/ l.string(),
    code: /*#__PURE__*/ l.string(),
    name: /*#__PURE__*/ l.string(),
    owner: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    memberCount: /*#__PURE__*/ l.integer(),
    memberLimit: /*#__PURE__*/ l.integer(),
    requireApproval: /*#__PURE__*/ l.boolean(),
    joinRule: /*#__PURE__*/ l.ref<JoinRule>((() => joinRule) as any),
    convo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
        (() => ConvoDefs.convoView) as any,
      ),
    ),
    viewer: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<JoinLinkViewerState>(
        (() => joinLinkViewerState) as any,
      ),
    ),
  }),
)

export { joinLinkPreviewView }

/** Preview for a disabled join link. Carries only the code so clients can correlate with the input and render a disabled state. */
type DisabledJoinLinkPreviewView = {
  $type?: 'chat.bsky.group.defs#disabledJoinLinkPreviewView'
  code: string
}

export type { DisabledJoinLinkPreviewView }

/** Preview for a disabled join link. Carries only the code so clients can correlate with the input and render a disabled state. */
const disabledJoinLinkPreviewView =
  /*#__PURE__*/ l.typedObject<DisabledJoinLinkPreviewView>(
    $nsid,
    'disabledJoinLinkPreviewView',
    /*#__PURE__*/ l.object({ code: /*#__PURE__*/ l.string() }),
  )

export { disabledJoinLinkPreviewView }

/** Preview for a join link code that does not map to an existing link. Carries only the code so clients can correlate with the input and render an invalid state. */
type InvalidJoinLinkPreviewView = {
  $type?: 'chat.bsky.group.defs#invalidJoinLinkPreviewView'
  code: string
}

export type { InvalidJoinLinkPreviewView }

/** Preview for a join link code that does not map to an existing link. Carries only the code so clients can correlate with the input and render an invalid state. */
const invalidJoinLinkPreviewView =
  /*#__PURE__*/ l.typedObject<InvalidJoinLinkPreviewView>(
    $nsid,
    'invalidJoinLinkPreviewView',
    /*#__PURE__*/ l.object({ code: /*#__PURE__*/ l.string() }),
  )

export { invalidJoinLinkPreviewView }

type JoinLinkViewerState = {
  $type?: 'chat.bsky.group.defs#joinLinkViewerState'
  requestedAt?: l.DatetimeString
}

export type { JoinLinkViewerState }

const joinLinkViewerState = /*#__PURE__*/ l.typedObject<JoinLinkViewerState>(
  $nsid,
  'joinLinkViewerState',
  /*#__PURE__*/ l.object({
    requestedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { joinLinkViewerState }

/** A join request from the perspective of the group owner. */
type JoinRequestView = {
  $type?: 'chat.bsky.group.defs#joinRequestView'
  convoId: string
  requestedBy: ActorDefs.ProfileViewBasic
  requestedAt: l.DatetimeString
}

export type { JoinRequestView }

/** A join request from the perspective of the group owner. */
const joinRequestView = /*#__PURE__*/ l.typedObject<JoinRequestView>(
  $nsid,
  'joinRequestView',
  /*#__PURE__*/ l.object({
    convoId: /*#__PURE__*/ l.string(),
    requestedBy: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    requestedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { joinRequestView }

/** A join request from the perspective of the requester, including enough group context to render the request in a list (e.g. group name, owner, member count). */
type JoinRequestConvoView = {
  $type?: 'chat.bsky.group.defs#joinRequestConvoView'
  convoId: string
  name: string
  owner: ActorDefs.ProfileViewBasic
  memberCount: number
  memberLimit: number
  viewer: JoinLinkViewerState
}

export type { JoinRequestConvoView }

/** A join request from the perspective of the requester, including enough group context to render the request in a list (e.g. group name, owner, member count). */
const joinRequestConvoView = /*#__PURE__*/ l.typedObject<JoinRequestConvoView>(
  $nsid,
  'joinRequestConvoView',
  /*#__PURE__*/ l.object({
    convoId: /*#__PURE__*/ l.string(),
    name: /*#__PURE__*/ l.string(),
    owner: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    memberCount: /*#__PURE__*/ l.integer(),
    memberLimit: /*#__PURE__*/ l.integer(),
    viewer: /*#__PURE__*/ l.ref<JoinLinkViewerState>(
      (() => joinLinkViewerState) as any,
    ),
  }),
)

export { joinRequestConvoView }
